import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SelectGroup from '../form/select-group';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        this.options = props.options;

        this.options.zodiac = {};
        props.signs.forEach((sign, key) => {
            this.options.zodiac[key + 1] = sign.name.charAt(0).toUpperCase() + sign.name.slice(1);
        });

        Object.keys(this.options.tarot).forEach(key => {
            const new_key = this.options.tarot[key].toLowerCase().replace(/ /g, '-');
            this.options.tarot[new_key] = this.options.tarot[key];
            delete this.options.tarot[key];
        });

        this.state = {
            default_sign: null,
            moon_sign_index: null,
            ascendant_sign_index: null,
            tarot_birth_card: null,
            celtic_sign: null,
            chinese_sign: null,
            life_path_number: null,
        };
    }

    render() {
        return (
            <cosmic-profile>
                {this.renderDefaultSign()}
                {this.renderMoonSign()}
                {this.renderRisingSign()}
                {this.renderTarotBirthCard()}
                {this.renderCelticSign()}
                {this.renderChineseSign()}
                {this.renderLifePathNumber()}
            </cosmic-profile>
        );
    }

    renderDefaultSign = () => {
        if (this.props.user.default_sign) {
            const default_sign = this.props.signs[this.props.user.default_sign - 1].name;
            const default_sign_image = 'https://gfx.tarot.com/images/site/channel-page/zodiac/' +
                default_sign + '/glyph.svg';

            return (
                <row className='is-wrap is-content-aligned-center is-aligned-center'>
                    <column className='is-3'>
                        <a href={`/astrology/zodiac/${default_sign}`}>
                            <img src={default_sign_image} alt={default_sign} />
                        </a>
                    </column>
                    <column className='is-9'>
                        <a href={`/astrology/zodiac/${default_sign}`}>
                            <h3>{default_sign} Sun</h3>
                        </a>
                    </column>
                    <column className='is-12'>
                        <SelectGroup
                            name='default_sign'
                            value={this.props.user.default_sign}
                            placeholder='Change Sun Sign'
                            options={this.options.zodiac}
                            onChange={this.handleChange}
                        />
                    </column>
                </row>
            );
        }

        return null;
    }

    renderMoonSign = () => {
        if (this.props.user.moon_sign_index) {
            const moon_sign = this.props.signs[this.props.user.moon_sign_index - 1].name;

            return (
                <row className='is-wrap is-content-aligned-center is-aligned-center'>
                    <column className='is-3'>
                        <a href={`/astrology/planets/moon-in-${moon_sign}`}>
                            <img
                                src={`https://gfx.tarot.com/images/site/channel-page/zodiac/${moon_sign}/glyph.svg`}
                                alt={moon_sign}
                            />
                        </a>
                    </column>
                    <column className='is-9'>
                        <a href={`/astrology/planets/moon-in-${moon_sign}`}>
                            <h3>{moon_sign} Moon</h3>
                        </a>
                    </column>
                    <column className='is-12'>
                        <SelectGroup
                            name='moon_sign_index'
                            value={this.props.user.moon_sign_index}
                            placeholder='Change Moon Sign'
                            options={this.options.zodiac}
                            onChange={this.handleChange}
                        />
                    </column>
                </row>
            );
        }

        return (
            <row className='is-wrap is-content-aligned-center is-aligned-center'>
                <column className='is-12'>
                    <a href='/astrology/planets/moon'>
                        <h3>Moon Sign</h3>
                    </a>
                </column>
                <column className='is-12'>
                    <SelectGroup
                        name='moon_sign_index'
                        value={this.props.user.moon_sign_index}
                        placeholder='Set Moon Sign'
                        options={this.options.zodiac}
                        onChange={this.handleChange}
                    />
                </column>
            </row>
        );
    }

    renderRisingSign = () => {
        if (this.props.user.ascendant_sign_index) {
            const ascendant_sign = this.props.signs[this.props.user.ascendant_sign_index - 1].name;
            const src=`https://gfx.tarot.com/images/site/channel-page/zodiac/${ascendant_sign}/glyph.svg`;

            return (
                <row className='is-wrap is-content-aligned-center is-aligned-center'>
                    <column className='is-3'>
                        <a href='/astrology/rising-sign'>
                            <img src={src} alt={ascendant_sign} />
                        </a>
                    </column>
                    <column className='is-9'>
                        <a href='/astrology/rising-sign'>
                            <h3>{ascendant_sign} Rising</h3>
                        </a>
                    </column>
                    <column className='is-12'>
                        <SelectGroup
                            name='ascendant_sign_index'
                            value={this.props.user.ascendant_sign_index}
                            placeholder='Change Rising Sign'
                            options={this.options.zodiac}
                            onChange={this.handleChange}
                        />
                    </column>
                </row>
            );
        }

        return (
            <row className='is-wrap is-content-aligned-center is-aligned-center'>
                <column className='is-12'>
                    <a href='/astrology/rising-sign'>
                        <h3>Rising Sign</h3>
                    </a>
                </column>
                <column className='is-12'>
                    <SelectGroup
                        name='ascendant_sign_index'
                        value={this.props.user.ascendant_sign_index}
                        placeholder='Set Rising Sign'
                        options={this.options.zodiac}
                        onChange={this.handleChange}
                    />
                </column>
            </row>
        );

    }

    renderTarotBirthCard = () => {
        return (
            <row className='is-wrap is-content-aligned-center is-aligned-center'>
                <column className='is-3'>
                    {this.renderTarotBirthCardImage()}
                </column>
                <column className='is-9'>
                    {this.renderTarotBirthCardTitle()}
                </column>
                <column className='is-12'>
                    <SelectGroup
                        name='tarot_birth_card'
                        value={this.props.user.tarot_birth_card}
                        placeholder='Change Tarot Birth Card'
                        options={this.options.tarot}
                        onChange={this.handleChange}
                    />
                </column>
            </row>
        );
    }

    renderTarotBirthCardImage = () => {
        if (this.props.deck) {
            const tarot_birth_card = this.props.deck.cards.filter(card => {
                return card.canonical_rank.replace(/the\-/, '') == this.props.user.tarot_birth_card; //eslint-disable-line no-useless-escape, max-len
            });

            if (tarot_birth_card.length) {
                return (
                    <a href={`/tarot/cards/${tarot_birth_card[0].canonical_rank}`}>
                        <img
                            src={tarot_birth_card[0].images.full}
                            alt={tarot_birth_card[0].name}
                            className='tarot-birth-card'
                        />
                    </a>
                );
            }
        }

        return null;
    }

    renderTarotBirthCardTitle = () => {
        if (this.props.deck) {
            const tarot_birth_card = this.props.deck.cards.filter(card => {
                return card.canonical_rank.replace(/the\-/, '') == this.props.user.tarot_birth_card; //eslint-disable-line no-useless-escape, max-len
            });

            if (tarot_birth_card.length) {
                return (
                    <a href={`/tarot/cards/${tarot_birth_card[0].canonical_rank}`}>
                        <h3>{tarot_birth_card[0].name.replace(/the /i, '')}</h3>
                    </a>
                );
            }
        }

        return null;
    }

    renderCelticSign = () => {
        if (this.props.user.celtic_sign) {
            const celtic_sign_image = 'https://gfx.tarot.com/images/site/tarot/cosmic-profile/mobile/celtic-' +
                this.props.user.celtic_sign + '.svg';

            return (
                <row className='is-wrap is-content-aligned-center is-aligned-center'>
                    <column className='is-3'>
                        <a href='/astrology/celtic-signs'>
                            <img src={celtic_sign_image} alt={this.props.user.celtic_sign} />
                        </a>
                    </column>
                    <column className='is-9'>
                        <a href='/astrology/celtic-signs'>
                            <h3>{this.props.user.celtic_sign} Tree</h3>
                        </a>
                    </column>
                    <column className='is-12'>
                        <SelectGroup
                            name='celtic_sign'
                            value={this.props.user.celtic_sign}
                            placeholder='Change Celtic Tree Sign'
                            options={this.options.celtic}
                            onChange={this.handleChange}
                        />
                    </column>
                </row>
            );
        }

        return null;
    }

    renderChineseSign = () => {
        if (this.props.user.chinese_sign) {
            const user = this.props.user;
            const chinese_sign_image = 'https://gfx.tarot.com/images/site/tarot/cosmic-profile/mobile/chinese-' +
                this.props.user.chinese_sign + '.svg';

            return (
                <row className='is-wrap is-content-aligned-center is-aligned-center'>
                    <column className='is-3'>
                        <a href={`/astrology/chinese-zodiac/${user.chinese_sign}`}>
                            <img src={chinese_sign_image} alt={user.chinese_sign} />
                        </a>
                    </column>
                    <column className='is-9'>
                        <a href={`/astrology/chinese-zodiac/${user.chinese_sign}`}>
                            <h3>{user.chinese_sign}</h3>
                        </a>
                    </column>
                    <column className='is-12'>
                        <SelectGroup
                            name='chinese_sign'
                            value={this.props.user.chinese_sign}
                            placeholder='Change Chinese Sign'
                            options={this.options.chinese}
                            onChange={this.handleChange}
                        />
                    </column>
                </row>
            );
        }

        return null;
    }

    renderLifePathNumber = () => {
        if (this.props.user.life_path_number) {
            const user = this.props.user;

            return (
                <row className='is-wrap is-content-aligned-center is-aligned-center'>
                    <column className='is-3'>
                        <a href={`/numerology/sun-numbers/${user.life_path_number}`}>
                            <img
                                src={`https://gfx.tarot.com/images/numerology/daily/${user.life_path_number}.jpg`}
                                alt={user.life_path_number}
                            />
                        </a>
                    </column>
                    <column className='is-9'>
                        <a href={`/numerology/sun-numbers/${user.life_path_number}`}>
                            <h3>{this.numberToWord(user.life_path_number)}</h3>
                        </a>
                    </column>
                    <column className='is-12'>
                        <SelectGroup
                            name='life_path_number'
                            value={this.props.user.life_path_number}
                            placeholder='Change Life Path Number'
                            options={this.options.numbers}
                            onChange={this.handleChange}
                        />
                    </column>
                </row>
            );
        }

        return null;
    }

    numberToWord(number) {
        const words = [
            '',
            'one',
            'two',
            'three',
            'four',
            'five',
            'six',
            'seven',
            'eight',
            'nine',
        ];

        return words[number];
    }

    handleChange = (e) => {
        this.props.userUpdate({ [e.target.name]: e.target.value });
        this.props.onChange(e.target.name, e.target.value);
    }
}

const mapStateToProps = (state) => ({
    deck: state.deck,
    options: state['cosmic-profile'],
    signs: state.zodiac && state.zodiac.signs,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    userUpdate: (payload) => dispatch({ type: 'user:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
